import { Component, Prop, h, Host, getAssetPath, State } from "@stencil/core";

@Component({
    tag: "ux-iws-nb-field-service-search",
    shadow: true,
    styleUrl: "nb-field-service-search.scss",
    assetsDirs: ["assets"],
})
export class NbFieldServiceSearch {
    /** API endpoint for the search */
    @Prop() endpoint: string;
    /** Selected technology for the search */
    @Prop() technology: string;
    /** ZIP label */
    @Prop() zipLabel: string = "PLZ";
    /** label for search button (only for A11y) */
    @Prop() searchButtonLabel: string = "Suchen";
    /** override default image for contact cards */
    @Prop() defaultImage: string = "";
    /** title for the search results */
    @Prop() resultsTitle: string = "Ihr passender Ansprechpartner";

    @State() hasResults: boolean = false;
    @State() noResults: boolean = false;
    @State() resultHtml: string = "";
    @State() zipMissing: boolean = false;

    private input: HTMLUxInputFieldElement;

    private fetchData = () => {
        const zipCode = this.input.value;
        if (!zipCode) {
            this.zipMissing = true;
            return;
        }
        this.zipMissing = false;
        this.hasResults = false;
        this.noResults = false;
        this.resultHtml = "";
        const isFullUrl = this.endpoint.startsWith("http");
        const url = isFullUrl
            ? new URL(this.endpoint)
            : new URL(this.endpoint, window.location.origin);
        url.searchParams.append("technology", this.technology);
        url.searchParams.append("plz", zipCode);

        fetch(url.toString())
            .then((response) => response.json())
            .then((data) => {
                if (!data.message) {
                    this.noResults = true;
                    return;
                }
                this.renderResults(data.message);
            });
    };

    private renderResults = (html: string) => {
        const resultsDiv = document.createElement("div");
        resultsDiv.innerHTML = html;
        resultsDiv.querySelectorAll("ux-iws-contact-card").forEach((card) => {
            if (!card.getAttribute("image")) {
                const defaultImage =
                    this.defaultImage || getAssetPath("assets/fallback.jpg");
                card.setAttribute("image", defaultImage);
            }
            card.setAttribute("variant", "nimbus");
        });
        this.resultHtml = resultsDiv.innerHTML;
        resultsDiv.remove();
        this.hasResults = true;
    };

    render() {
        return (
            <Host
                style={{
                    "--ux-iws-field-service-search-background-image": `url("${getAssetPath("assets/background.jpg")}")`,
                }}
            >
                <div class="initial-container">
                    <div class="intro-text">
                        <slot name="intro"></slot>
                    </div>
                    <form
                        onSubmit={(e) => {
                            e.preventDefault();
                            this.fetchData();
                        }}
                    >
                        <ux-input-field
                            ref={(el) => (this.input = el)}
                            label={this.zipLabel}
                            error={this.zipMissing}
                        ></ux-input-field>
                        <ux-button
                            type="submit"
                            size="icon"
                            variant="primary"
                            label={this.searchButtonLabel}
                        >
                            <ux-icon
                                style={{ fontSize: "17px" }}
                                name="arrow-right"
                                slot="icon"
                            ></ux-icon>
                        </ux-button>
                    </form>
                </div>
                <div
                    class={{ results: true, hidden: !this.hasResults }}
                    aria-hidden={!this.hasResults}
                >
                    <h2 class="results-title">{this.resultsTitle}</h2>
                    <div
                        class="results-container"
                        innerHTML={this.resultHtml}
                    ></div>
                </div>
                <div
                    class={{ "no-results": true, hidden: !this.noResults }}
                    aria-hidden={!this.noResults}
                >
                    <slot name="no-results"></slot>
                </div>
            </Host>
        );
    }
}
